module.exports = __webpack_public_path__ + "img/cards2.1caef1a6.jpg";